import { FULL_ACCESS_ROLES, MODULE_KEYS, PAGE_KEYS } from './keys';
import type { AppModuleDefinition } from './types';

// The transporter's own phone page, "My trips". Sync and grant it from /permission; backend
// permissions remain authoritative. `Transporter` is his role (v2); `Pet Transport Partner`
// stays until the migration has moved every login over.
const TRANSPORTER_SELF_ROLES = [...FULL_ACCESS_ROLES, 'Transporter', 'Pet Transport Partner'];
// Staff who run the transporters: dispatch, the clinic's coordinator, accounts.
const TRANSPORTERS_ROLES = [...FULL_ACCESS_ROLES, 'Pet Transport Dispatcher', 'Pet Transport Coordinator', 'Accounts Manager'];

export const petTransportModules: AppModuleDefinition[] = [{
  key: MODULE_KEYS.PET_TRANSPORT,
  label: 'Pet transport', labelKey: 'alkokh.petTransport.title', icon: 'tabler-paw',
  fallbackRoles: TRANSPORTER_SELF_ROLES,
  nav: { order: 77.5, titleKey: 'alkokh.petTransport.myTitle', icon: 'tabler-paw' },
  pages: [{
    key: PAGE_KEYS.PET_TRANSPORT_ME,
    label: 'My pet trips', labelKey: 'alkokh.petTransport.myTitle',
    paths: ['/pet-transport/me'], routeNames: ['pet-transport-me'], fallbackRoles: TRANSPORTER_SELF_ROLES,
    nav: { order: 20, titleKey: 'alkokh.petTransport.myTitle', icon: 'tabler-paw', to: { path: '/pet-transport/me' } },
  }],
}, {
  /**
   * The clinic's transporters — a record of their own, separate from delivery partners:
   * settings, jobs, cash box and settlement. Contract: docs/README.transporter-entity-backend-prompt.md.
   * ⚠️ Registering these keys gates the pages: grant them in /permission after the sync.
   */
  key: MODULE_KEYS.TRANSPORTERS,
  label: 'Transporters', labelKey: 'alkokh.transporters.title', icon: 'tabler-truck',
  fallbackRoles: TRANSPORTERS_ROLES,
  nav: { order: 76.5, titleKey: 'alkokh.transporters.title', icon: 'tabler-truck', singlePage: true },
  pages: [{
    key: PAGE_KEYS.TRANSPORTERS_LIST,
    label: 'Transporters', labelKey: 'alkokh.transporters.title',
    paths: ['/transporters'], routeNames: ['transporters'], fallbackRoles: TRANSPORTERS_ROLES,
    nav: { order: 10, titleKey: 'alkokh.transporters.title', icon: 'tabler-truck', to: { path: '/transporters' } },
  }, {
    key: PAGE_KEYS.TRANSPORTERS_DETAIL,
    label: 'Transporter', labelKey: 'alkokh.transporters.detailTitle',
    pathPrefixes: ['/transporters/'], routeNames: ['transporters-id'], fallbackRoles: TRANSPORTERS_ROLES,
  }],
  shortcuts: [
    { icon: 'tabler-truck', title: 'Transporters', subtitle: 'Trips, cash box & settlement', to: { path: '/transporters' }, accessKey: PAGE_KEYS.TRANSPORTERS_LIST, order: 46 },
  ],
  search: [
    { group: 'Operations', icon: 'tabler-truck', title: 'Transporters', url: { path: '/transporters' }, accessKey: PAGE_KEYS.TRANSPORTERS_LIST, order: 48 },
  ],
}];
